import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import FormData from "form-data";
import { useNavigate } from "react-router-dom";

import { injectModels } from "../../redux/injectModels";
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const number = /^\d{10}$/;

const CreateUser = (props) => {
  const buttonRef = useRef(null);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [about, setAbout] = useState("");
  const [job, setJob] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const [usernameError, setUsernameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [macAddressError, setMacAddressError] = useState("");
  const [profileImageError, setProfileImageError] = useState("");
  const [aboutError, setAboutError] = useState("");
  const [jobError, setJobError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [cityError, setCityError] = useState("");
  const [stateError, setStateError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const [error, setError] = useState("");

  const handleUsername = (e) => {
    const val = e.target.value;
    if (val === "") {
      setUsernameError("Username is required!");
    } else {
      setUsernameError("");
    }
    setUsername(val);
  };

  const handleEmail = (e) => {
    const val = e.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (val === "") {
      setEmailError("Email is required!");
    } else if (!emailRegex.test(val)) {
      setEmailError("Invalid email format!");
    } else {
      setEmailError("");
    }
    setEmail(val);
  };
  const handlePassword = (e) => {
    const val = e.target.value;
    if (val === "") {
      setPasswordError("Password is required!");
    } else {
      setPasswordError("");
    }
    setPassword(val);
  };
  const handleMacAddress = (e) => {
    const val = e.target.value;
    if (val === "") {
      setMacAddress("IP Address is required!");
    } else {
      setMacAddressError("");
    }
    setMacAddress(val);
  };

  const handleProfileImage = (e) => {
    const file = e.target.files[0];
    setProfileImage(file);
    if (!file) {
      setProfileImageError("Profile Image is required!");
    } else {
      setProfileImageError("");
    }
  };

  const handleAbout = (e) => {
    const val = e.target.value;
    if (val === "") {
      setAbout("About is required!");
    } else {
      setAboutError("");
    }
    setAbout(val);
  };

  const handleJob = (e) => {
    const val = e.target.value;
    if (val === "") {
      setJob("Job is required!");
    } else {
      setJobError("");
    }
    setJob(val);
  };
  const handleAddress = (e) => {
    const val = e.target.value;
    if (val === "") {
      setAddress("Address is required!");
    } else {
      setAddressError("");
    }
    setAddress(val);
  };

  const handlePhoneNumber = async (e) => {
    e.preventDefault();
    let inputValue = e.target.value;
    if (inputValue.length < 6 || inputValue.length > 13) {
      setPhoneNumberError("Enter a valid Mobile Number ");
    } else if (
      number.test(/^(\+\d{1,3}[- ]?)?\d{10}$/) &&
      !number.match(/0{5,}/)
    ) {
      setPhoneNumberError("Enter a valid mobile number");
    } else {
      setPhoneNumberError("");
    }
    setPhoneNumber(inputValue);
  };

  const handleCity = (e) => {
    const val = e.target.value;
    if (val === "") {
      setCity("City is required!");
    } else {
      setCityError("");
    }
    setCity(val);
  };
  const handleState = (e) => {
    const val = e.target.value;
    if (val === "") {
      setState("State is required!");
    } else {
      setStateError("");
    }
    setState(val);
  };
  const handleCountry = (e) => {
    const val = e.target.value;
    if (val === "") {
      setCountry("Country is required!");
    } else {
      setCountryError("");
    }
    setCountry(val);
  };
  const handlePostalCode = (e) => {
    const val = e.target.value;
    if (val === "") {
      setPostalCode("Post code is required!");
    } else {
      setPostalCodeError("");
    }
    setPostalCode(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = true;

    if (username.trim() === "") {
      error = false;
      setUsernameError("Username is required!");
    } else {
      setUsernameError("");
    }

    if (email.trim() === "") {
      setEmailError("Email is required");
      error = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter the correct Email!");
      error = false;
    } else {
      setEmailError("");
    }
    if (password.trim() === "") {
      error = false;
      setPasswordError("Password is required!");
    } else {
      setPasswordError("");
    }

    if (macAddress === "") {
      error = false;
      setMacAddressError("IP Address is required!");
    } else {
      setMacAddressError("");
    }

    if (profileImage === "") {
      error = false;
      setProfileImageError("Profile Image is required!");
    } else {
      setProfileImageError("");
    }

    if (about === "") {
      error = false;
      setAboutError("About Us is required!");
    } else {
      setAboutError("");
    }
    if (job === "") {
      error = false;
      setJobError("Job is required!");
    } else {
      setJobError("");
    }
    if (address === "") {
      error = false;
      setAddressError("Address is required!");
    } else {
      setAddressError("");
    }
    if (phoneNumber.length < 6 || phoneNumber.length > 13) {
      error = false;
      setPhoneNumberError("Phone Number is required");
    } else if (
      number.test(/^(\+\d{1,3}[- ]?)?\d{10}$/) &&
      !number.match(/0{5,}/)
    ) {
      error = false;
      setPhoneNumberError("Enter a Valid Mobile Number");
    } else {
      setPhoneNumber("");
    }
    if (city === "") {
      error = false;
      setCityError("City is required!");
    } else {
      setCityError("");
    }
    if (state === "") {
      error = false;
      setStateError("State is required!");
    } else {
      setStateError("");
    }
    if (country === "") {
      error = false;
      setCountryError("Country is required!");
    } else {
      setCountryError("");
    }
    if (postalCode === "") {
      error = false;
      setPostalCodeError("PostalCode is required!");
    } else {
      setPostalCodeError("");
    }

    if (!error) {
      setError("Please fill all fields!");
      return;
    } else {
      setError("");
      try {
        let data = new FormData();
        data.append("username", username);
        data.append("email", email);
        data.append("password", password);
        data.append("mac_address", macAddress);
        data.append("profile_image", profileImage);
        data.append("about", about);
        data.append("job", job);
        data.append("address", address);
        data.append("phone_number", phoneNumber);
        data.append("city", city);
        data.append("state", state);
        data.append("country", country);
        data.append("postal_code", postalCode);
        data.append("role", "user");

        props.application.setLoading(true);
        const res = await props.admin.createUser(data);

        if (res.success === true) {
          props.application.setLoading(false);
          toast.success(res.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          handleResetForm();
          const button = buttonRef.current;
          if (button) {
            button.click();
          }
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.application.setLoading(false);
        }
      } catch (error) {
        console.log(error);
        props.application.setLoading(false);
        toast.error("Something went wrong!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  const handleResetForm = () => {
    setUsername("");
    setEmail("");
    setPassword("");
    setMacAddress("");
    setProfileImage("");
    setAbout("");
    setJob("");
    setAddress("");
    setPhoneNumber("");
    setCity("");
    setState("");
    setCountry("");
    setPostalCode("");
  };
  const handleForm = () => {
    setUsernameError("");
    setEmailError("");
    setPasswordError("");
    setMacAddressError("");
    setProfileImageError("");
    setAboutError("");
    setJobError("");
    setAddressError("");
    setPhoneNumberError("");
    setCityError("");
    setStateError("");
    setCountryError("");
    setPostalCodeError("");
  };

  return (
    <div className="modal fade" id="largeModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create User</h5>
            <button
              ref={buttonRef}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleForm}
            ></button>
          </div>
          <div className="modal-body">
            <form className="row g-3 p-2" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Username
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={handleUsername}
                  maxLength={20}
                />
                {usernameError && (
                  <div className="text-danger">{usernameError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={handleEmail}
                  maxLength={90}
                />
                {emailError && <div className="text-danger">{emailError}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={handlePassword}
                  maxLength={240}
                />
                {passwordError && (
                  <div className="text-danger">{passwordError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Mac Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={macAddress}
                  onChange={handleMacAddress}
                  maxLength={80}
                />
                {macAddressError && (
                  <div className="text-danger">{macAddressError}</div>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="profileImage">Profile Image</label>
                <input
                  type="file"
                  className="form-control"
                  id="profileImage"
                  accept="image/*"
                  onChange={handleProfileImage}
                />
                {profileImageError && (
                  <div className="text-danger">{profileImageError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  About
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={about}
                  onChange={handleAbout}
                />
                {aboutError && <div className="text-danger">{aboutError}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Job
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={job}
                  onChange={handleJob}
                  maxLength={40}
                />
                {jobError && <div className="text-danger">{jobError}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Address
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={address}
                  onChange={handleAddress}
                  maxLength={250}
                />
                {addressError && (
                  <div className="text-danger">{addressError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Phone Number
                </label>
                <input
                  min={"0"}
                  type="Number"
                  className="form-control"
                  value={phoneNumber}
                  onChange={handlePhoneNumber}
                  maxLength={12}
                />
                {phoneNumberError && (
                  <div className="text-danger">{phoneNumberError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  City
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={city}
                  onChange={handleCity}
                  maxLength={40}
                />
                {cityError && <div className="text-danger">{cityError}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  State
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={state}
                  onChange={handleState}
                  maxLength={40}
                />
                {stateError && <div className="text-danger">{stateError}</div>}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Country
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={country}
                  onChange={handleCountry}
                  maxLength={40}
                />
                {countryError && (
                  <div className="text-danger">{countryError}</div>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  Postal Code
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={postalCode}
                  onChange={handlePostalCode}
                  maxLength={8}
                />
                {postalCodeError && (
                  <div className="text-danger">{postalCodeError}</div>
                )}
              </div>
              <div className="mbtn-row">
                <button
                  type="button"
                  className="btn btn-secondary m-0"
                  data-bs-dismiss="modal"
                  onClick={handleForm}
                >
                  Reset
                </button>
                <button type="submit" className="btn btn-primary m-0">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectModels(["admin", "application"])(CreateUser);
